export interface Link {
  title?: string;
  route: string;
  permission?: string;
  icon: string;
  flatIcon: string;
  bootstrapIcon: string;
  color: string;
}

export const PREFIX_MAP: { [key: string]: Link } = {
  'USR': {
    title: 'Users',
    route: 'system/user',
    permission: 'USER_READ',
    icon: 'icons/duotune/communication/com013.svg',
    flatIcon: 'flaticon2-user-outline-symbol',
    bootstrapIcon: 'bi bi-person',
    color: 'info'
  },
  'ROL': {
    title: 'Roles',
    route: 'system/roles',
    permission: 'ROLE_READ',
    icon: 'icons/duotune/general/gen049.svg',
    flatIcon: 'flaticon2-shield',
    bootstrapIcon: 'bi bi-shield-lock',
    color: 'warning'
  },
  'CST': {
    title: 'Customers',
    route: 'customer',
    permission: 'CUSTOMER_READ',
    icon: 'icons/duotune/communication/com013.svg',
    flatIcon: 'flaticon2-user-outline-symbol',
    bootstrapIcon: 'bi bi-people',
    color: 'primary'
  },
  'SFX': {
    title: 'Burse Flex',
    route: 'savings/flex',
    permission: 'SAVINGS_READ',
    icon: 'icons/duotune/finance/fin002.svg',
    flatIcon: 'flaticon2-safe',
    bootstrapIcon: 'bi bi-piggy-bank',
    color: 'success'
  },
  'SVL': {
    title: 'Burse Vault',
    route: 'savings/vault',
    permission: 'SAVINGS_READ',
    icon: 'icons/duotune/finance/fin002.svg',
    flatIcon: 'flaticon2-safe',
    bootstrapIcon: 'bi bi-lock',
    color: 'primary'
  },
  'SBW': {
    title: 'Build Wealth',
    route: 'savings/build-wealth',
    permission: 'SAVINGS_READ',
    icon: 'icons/duotune/finance/fin002.svg',
    flatIcon: 'flaticon2-safe',
    bootstrapIcon: 'bi bi-graph-up-arrow',
    color: 'primary'
  },
  'STG': {
    title: 'Target Savings',
    route: 'savings/target',
    permission: 'SAVINGS_READ',
    icon: 'icons/duotune/finance/fin002.svg',
    flatIcon: 'flaticon2-safe',
    bootstrapIcon: 'bi bi-bullseye',
    color: 'info'
  },
  'SHI': {
    title: 'Savings History',
    route: 'savings/history',
    permission: 'SAVINGS_HISTORY_READ',
    icon: 'icons/duotune/general/gen064.svg',
    flatIcon: 'flaticon2-clock',
    bootstrapIcon: 'bi bi-clock-history',
    color: 'warning'
  },
  'DEP': {
    title: 'Deposits',
    route: 'finance/deposits',
    permission: 'FINANCE_DEPOSITS_READ',
    icon: 'icons/duotune/finance/fin001.svg',
    flatIcon: 'flaticon2-building',
    bootstrapIcon: 'bi bi-cash-stack',
    color: 'success'
  },
  'AUD': {
    title: 'Audit',
    route: 'system/audit',
    permission: 'AUDIT_READ',
    icon: 'icons/duotune/files/fil016.svg',
    flatIcon: 'flaticon2-analytics',
    bootstrapIcon: 'bi bi-clipboard-data',
    color: 'primary'
  },
  'APR': {
    title: 'Approvals',
    route: 'system/approvals',
    permission: 'APPROVAL_READ',
    icon: 'icons/duotune/general/gen048.svg',
    flatIcon: 'flaticon2-check-mark',
    bootstrapIcon: 'bi bi-check-circle',
    color: 'success'
  },
  'AN': {
    title: 'Notifications',
    route: 'account/notifications',
    permission: 'NOTIFICATION',
    icon: 'icons/duotune/general/gen007.svg',
    flatIcon: 'flaticon2-bell-4',
    bootstrapIcon: 'bi bi-bell',
    color: 'success'
  }
}

export const CATEGORY_MAP: { [key: string]: Link } = {
  'user': {
    route: 'system/user',
    permission: 'USER_READ',
    icon: 'icons/duotune/communication/com013.svg',
    flatIcon: 'flaticon2-user-outline-symbol',
    bootstrapIcon: 'bi bi-person',
    color: 'info'
  },
  'customer': {
    route: 'customer',
    permission: 'CUSTOMER_READ',
    icon: 'icons/duotune/communication/com013.svg',
    flatIcon: 'flaticon2-user-outline-symbol',
    bootstrapIcon: 'bi bi-people',
    color: 'primary'
  },
  'role': {
    route: 'system/roles',
    permission: 'ROLE_READ',
    icon: 'icons/duotune/general/gen049.svg',
    flatIcon: 'flaticon2-shield',
    bootstrapIcon: 'bi bi-shield-lock',
    color: 'warning'
  },
  'audit': {
    route: 'system/audit',
    permission: 'AUDIT_READ',
    icon: 'icons/duotune/files/fil016.svg',
    flatIcon: 'flaticon2-analytics',
    bootstrapIcon: 'bi bi-clipboard-data',
    color: 'primary'
  },
  'notification': {
    route: 'account/notifications',
    permission: 'NOTIFICATION',
    icon: 'icons/duotune/general/gen007.svg',
    flatIcon: 'flaticon2-bell-4',
    bootstrapIcon: 'bi bi-bell',
    color: 'success'
  },
  'deposits': {
    route: 'finance/deposits',
    permission: 'FINANCE_DEPOSITS_READ',
    icon: 'icons/duotune/finance/fin001.svg',
    flatIcon: 'flaticon2-building',
    bootstrapIcon: 'bi bi-cash-stack',
    color: 'success'
  },
  'approval': {
    route: 'system/approvals',
    permission: 'APPROVAL_READ',
    icon: 'icons/duotune/general/gen048.svg',
    flatIcon: 'flaticon2-check-mark',
    bootstrapIcon: 'bi bi-check-circle',
    color: 'success'
  },
  'savings-flex': {
    route: 'savings/flex',
    permission: 'SAVINGS_READ',
    icon: 'icons/duotune/finance/fin002.svg',
    flatIcon: 'flaticon2-safe',
    bootstrapIcon: 'bi bi-piggy-bank',
    color: 'success'
  },
  'savings-vault': {
    route: 'savings/vault',
    permission: 'SAVINGS_READ',
    icon: 'icons/duotune/finance/fin002.svg',
    flatIcon: 'flaticon2-safe',
    bootstrapIcon: 'bi bi-lock',
    color: 'primary'
  },
  'savings-build-wealth': {
    route: 'savings/build-wealth',
    permission: 'SAVINGS_READ',
    icon: 'icons/duotune/finance/fin002.svg',
    flatIcon: 'flaticon2-safe',
    bootstrapIcon: 'bi bi-graph-up-arrow',
    color: 'primary'
  },
  'savings-target': {
    route: 'savings/target',
    permission: 'SAVINGS_READ',
    icon: 'icons/duotune/finance/fin002.svg',
    flatIcon: 'flaticon2-safe',
    bootstrapIcon: 'bi bi-bullseye',
    color: 'info'
  }
}

export const ROUTE_MAP: { [key: string]: string } = {
  'system/user': 'USR',
  'system/roles': 'ROL',
  'system/audit': 'AUD',
  'system/approvals': 'APR',
  'customer': 'CST',
  'savings/flex': 'SFX',
  'savings/vault': 'SVL',
  'savings/build-wealth': 'SBW',
  'savings/target': 'STG',
  'savings/history': 'SHI',
  'finance/deposits': 'DEP',
  'account/notifications': 'AN'
}

export function getPrefix(ref: string) {
  let prefix;
  let refEval = ref;
  if (ref.indexOf('|') > -1) {
    const parts = ref.split('|');
    const lastPart = parts[parts.length - 1];
    const firstPart = parts[0];
    if (parts.length === 2 && !Number.isNaN(lastPart)) {
      refEval = firstPart;
    }
  }
  for (const key in PREFIX_MAP) {
    if (refEval.startsWith(key)) {
      prefix = key;
      break;
    }
  }
  if (!prefix && /^[0-9a-fA-F]{24}$/.test(refEval)) {
    prefix = 'CST';
  }
  return prefix;
}

export function getLink(route: string) {
  return PREFIX_MAP[ROUTE_MAP[route]];
}

export function getLinkByRef(ref: string) {
  const prefix = getPrefix(ref);
  if (prefix) {
    return PREFIX_MAP[prefix];
  }
}

export function getLinkByPrefix(prefix: string) {
  return PREFIX_MAP[prefix];
}

export function getLinkByCategory(category: string) {
  return CATEGORY_MAP[category];
}

export function isRefRoute(route: string) {
  if (!route) return false;
  let segments = route.split('/');
  if (segments.length < 3) return false;
  let ref = segments[segments.length - 1];
  if (!ref) return false;
  return !!getPrefix(ref);
}

export function getLinkByFullRoute(route: string) {
  let segments = route.split('/');
  let link;
  if (segments.length == 3) {
    link = getLink(route.startsWith('/') ? route.slice(1) : route);
    if (!!link) return link;
  } else if (segments.length == 4) {
    link = getLinkByRef(segments[3]);
    if (!!link) {
      link.route = route;
      link.title = segments[3].toUpperCase();
      return link;
    }
  }
  if (!link) {
    link = {
      route: route,
      permission: 'UNKNOWN',
      icon: 'icons/duotune/general/gen064.svg',
      flatIcon: 'flaticon2-analytics',
      bootstrapIcon: 'bi bi-clipboard-data',
      color: 'danger'
    }
  }
  return link;
}
